import { MenuItemProps, Menu as MuiMenu, MenuProps as MuiMenuProps, MenuItem as MuiMenuItem } from '@mui/material';
import { createContext, forwardRef, useContext, useState } from 'react';

type MenuContextType = {
  onClose: () => void;
  onOpen: (e: React.MouseEvent<HTMLElement>) => void;
  anchorEl: HTMLElement | null;
  open: boolean;
};

const MenuContext = createContext<MenuContextType>({
  onClose: () => undefined,
  onOpen: () => undefined,
  anchorEl: null,
  open: false,
});

export type MenuProps = Omit<MuiMenuProps, 'open'> & {
  renderAnchor: (opts: { onClick: (e: React.MouseEvent<HTMLElement>) => void }) => React.ReactNode;
};
export const Menu: React.FC<MenuProps> = (props) => {
  const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);
  const onClose = () => setAnchorEl(null);
  const onOpen = (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget);

  return (
    <MenuContext.Provider value={{ onClose, onOpen, anchorEl, open }}>
      {props.renderAnchor({ onClick: onOpen })}
      <MuiMenu
        {...props}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
      />
    </MenuContext.Provider>
  );
};

export type MenuTriggerProps = {
  children: React.ReactElement;
  asChild?: boolean;
};

export const MenuItem = forwardRef<HTMLLIElement, MenuItemProps>((props, ref) => {
  const context = useContext(MenuContext);

  return (
    <MuiMenuItem
      {...props}
      ref={ref}
      onClick={(e) => {
        context.onClose();
        props.onClick?.(e);
      }}
    />
  );
});
